import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SearchHome = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const opciones = [
    {
      imagen: "/img/buscar_discapacidad.webp",
      titulo: t("search_profiles.by_profile", "Por características del perfil de handicap"),
      ruta: "/buscar/perfil",
    },
    {
      imagen: "/img/buscar_enfermedad_rara.webp",
      titulo: t("search_profiles.by_condition", "Por enfermedad"),
      ruta: "/buscar/enfermedad",
    },
    {
      imagen: "/img/buscar_amigos.webp",
      titulo: t("search_profiles.by_friends", "Ver amigos"),
      ruta: "/buscar/amigos",
    },
  ];

  return (
    <div className="max-w-6xl mx-auto px-6 py-12 text-center">

      <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-3">
        {opciones.map((opcion) => (
          <div
            key={opcion.ruta}
            onClick={() => navigate(opcion.ruta)}
            className="cursor-pointer bg-white p-5 rounded-2xl shadow-md hover:shadow-xl transition duration-300 border border-blue-100 hover:border-blue-400 overflow-hidden"
          >
            <img
              src={opcion.imagen}
              alt={opcion.titulo}
              className="w-full aspect-square object-cover rounded-xl mb-5"
            />
            <h3 className="text-xl font-semibold text-blue-700">{opcion.titulo}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchHome;
